(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollReveal() {
    if (prefersReducedMotion) return;

    var selectors = [
      '.card-wrapper',
      '.collection-list__item',
      '.banner__content',
      '.rich-text__blocks > *',
      '.multicolumn-card',
      '.bp-reveal-target',
    ];
    var targets = document.querySelectorAll(selectors.join(','));
    if (!targets.length) return;

    var groups = new Map();
    targets.forEach(function (el) {
      if (el.closest('[data-age-gate-card]')) return;
      el.classList.add('bp-reveal');
      var parent = el.parentElement;
      var count = groups.get(parent) || 0;
      el.style.setProperty('--bp-i', count % 4);
      groups.set(parent, count + 1);
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px 35% 0px' }
    );

    document.querySelectorAll('.bp-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Carbonation burst: bubbles twinkle in place across the button — opacity
     only, nothing rises or rotates. */
  function spawnBubbles(button) {
    if (prefersReducedMotion) return;

    var host = button.querySelector('.bp-bubble-field');
    if (!host) {
      host = document.createElement('span');
      host.className = 'bp-bubble-field';
      if (getComputedStyle(button).position === 'static') {
        button.style.position = 'relative';
      }
      button.appendChild(host);
    }

    var count = 8;
    for (var i = 0; i < count; i++) {
      (function (index) {
        var bubble = document.createElement('span');
        bubble.className = 'bp-bubble';
        var size = 0.35 + Math.random() * 0.55;
        var xPos = 8 + Math.random() * 84;
        var yPos = 15 + Math.random() * 70;
        bubble.style.setProperty('--bp-bubble-size', size + 'rem');
        bubble.style.setProperty('--bp-bubble-x', xPos + '%');
        bubble.style.setProperty('--bp-bubble-y', yPos + '%');
        bubble.style.animationDelay = index * 55 + 'ms';
        host.appendChild(bubble);
        window.setTimeout(function () {
          bubble.remove();
        }, 900 + index * 55);
      })(i);
    }
  }

  /* Pour state: while the add-to-cart request is in flight the button fills
     bottom-up (.bp-pouring). Dawn toggles a `loading` class on the submit
     button around the fetch; mirror it and fall back to a timeout. */
  function startPour(button) {
    if (prefersReducedMotion) return;
    button.classList.add('bp-pouring');

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      button.classList.remove('bp-pouring');
      if (watcher) watcher.disconnect();
    };

    var watcher = new MutationObserver(function () {
      var spinner = button.querySelector('.loading__spinner');
      var spinnerHidden = !spinner || spinner.classList.contains('hidden');
      if (!button.classList.contains('loading') && spinnerHidden) {
        window.setTimeout(finish, 250);
      }
    });
    watcher.observe(button, { attributes: true, attributeFilter: ['class'], subtree: true });
    window.setTimeout(finish, 4000);
  }

  function initAddToCartFeedback() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('button[name="add"]');
      if (!button || button.disabled) return;
      spawnBubbles(button);
      startPour(button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollReveal();
      initAddToCartFeedback();
    });
  } else {
    initScrollReveal();
    initAddToCartFeedback();
  }
})();
